<div class="card  h-100 mb-4 rounded-0 context-menu">
   <!-- <div class="row px-3 pt-4">

        <div class="col-md-11">
            <div class="row px-4">
                <div>
                    <img src="../../../../assets/common/images/Activities/dashboardCalendar.svg" class="h-20px w-20px" />

                </div>
                <div class="font-weight-bolder h6 text-left ml-3">
                    My Task List
                </div>
            </div>


        </div>
        <div *ngIf="isLoaded && isTaskListRecordsEmpty" class="col-md-1">
            <div class="font-weight-bolder text-primary text-center cursor-pointer" (click)="viewall()">
                View All
            </div>
        </div>
    </div>
-->

    <div class="px-4 d-flex mt-3">
        <div>
            <img src="../../../../assets/common/images/Activities/dashboardCalendar.svg" class="h-20px w-20px rounded" />

        </div>
        <div class="pl-3">
            <div class="font-weight-bolder h5">
                {{'MyTaskList' | localize}}
            </div>
        </div>
        <div *ngIf="isLoaded && isTaskListRecordsEmpty" class="ml-auto cursor-pointer">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>


    <!--Shimmer Section Code-->
    <div *ngIf="!isLoaded && !isTaskListRecordsEmpty">
        <div class="row">
            <div class="col-md-2">

                <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


            </div>

            <div class="col-md-2">

                <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


            </div>

            <div class="col-md-2">

                <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


            </div>

            <div class="col-md-2">

                <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


            </div>
            <div class="col-md-2">

                <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


            </div>

            <div class="col-md-2">

                <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


            </div>

        </div>
    </div>

    <div>
        <div *ngIf="isLoaded && !isTaskListRecordsEmpty" class="card h-350px">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-20">
                    <img src="../../../../assets/common/images/new-dashboard/task-list-empty-ui.svg" class="h-200px w-275px ml-8" />
                    <h6 class="text-muted text-center mt-4 ml-22">{{'NoDataFounds'|localize}}</h6>
                </div>
            </div>
        </div>


    </div>



    <!--old task list p-table-->
    <!--<div *ngIf="isLoaded && !isTaskListRecordsEmpty">
            <div class="row px-4 mb-3 pt-5">
                <div class="col-md-12">
                    <div id="TaskList-data-table">
                        <p-table [value]="this.tasktaskList" [rows]="4" [paginator]="true">
                            <ng-template pTemplate="header">
                                <tr [ngClass]="'textcolor'">
                                    <th style="width: 30%;">Project Name</th>
                                    <th style="width: 30%;">Task</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th class="text-center">Status</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-UserProjectTaskListDto>
                                <tr [ngClass]="'textcolor'">



                                    <td>
                                        <div class="d-flex">
                                            <div class="d-flex align-items-center">

                                                <div class="symbol symbol-35 symbol-warning">
                                                    <div class="symbol-label font-weight-boldest">{{UserProjectTaskListDto.projectName | slice:0:3 }}</div>

                                                </div>
                                            </div>
                                            <div class="d-flex flex-column ml-3 justify-content-center">

                                                <div class="font-weight-bold" pTooltip="{{UserProjectTaskListDto.projectName}}" [tooltipDisabled]="DisableTooltip(UserProjectTaskListDto.projectName, 16)" tooltipPosition="bottom">{{ UserProjectTaskListDto.projectName | slice:0:16}}{{getUserlength(UserProjectTaskListDto.taskDescription)>16? '..' : ''}}</div>
                                                <div class="font-size-14" pTooltip="{{UserProjectTaskListDto.taskDescription}}" [tooltipDisabled]="DisableTooltip(UserProjectTaskListDto.taskDescription, 16)" tooltipPosition="bottom">


                                                    {{UserProjectTaskListDto.taskDescription| slice:0:16}}{{getUserlength(UserProjectTaskListDto.taskDescription)>16 ? '..' : '' }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="row no-gutters">
                                            <div class=" mb-2" pTooltip="{{UserProjectTaskListDto.taskName}}" [tooltipDisabled]="DisableTooltip(UserProjectTaskListDto.taskName, 16)" tooltipPosition="bottom">
                                                {{ UserProjectTaskListDto.taskName | slice:0:15}}{{getUserlength(UserProjectTaskListDto.taskDescription)>16 ? '..' : '' }}

                                            </div>

                                        </div>

                                    </td>
                                    <td>
                                        <span *ngIf="UserProjectTaskListDto.startTime != null">
                                            {{UserProjectTaskListDto.startTime | dateFormat }}

                                        </span>

                                        <span *ngIf="UserProjectTaskListDto.startTime == null">
                                            -
                                        </span>

                                    </td>
                                    <td>
                                        <span *ngIf="UserProjectTaskListDto.endTime != null">
                                            {{UserProjectTaskListDto.endTime | dateFormat}}

                                        </span>

                                        <span *ngIf="UserProjectTaskListDto.endTime == null">
                                            -
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span class="ml-2" [ngClass]="{'text-success': UserProjectTaskListDto.taskStateId == 1,
    'text-danger': UserProjectTaskListDto.taskStateId == 2,'text-warning': UserProjectTaskListDto.taskStateId == 3}"></span>
                                        <span *ngIf="UserProjectTaskListDto.taskStateId == 1" class="ml-2 text-primary">
                                            New

                                        </span>
                                        <span *ngIf="UserProjectTaskListDto.taskStateId == 2" class="ml-2 text-warning">
                                            In progress

                                        </span>
                                        <span *ngIf="UserProjectTaskListDto.taskStateId == 3" class="ml-2 text-danger">
                                            Overdue
                                        </span>
                                        <span *ngIf="UserProjectTaskListDto.taskStateId == 4" class="ml-2 text-success">
                                            Completed
                                        </span>


                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

            </div>

        </div>-->
    <!--updated task list p-table-->

    <div *ngIf="isLoaded && isTaskListRecordsEmpty" class="row px-4 mb-2 mt-2">
        <div class="col-md-12">
            <div id="TaskList-data-table">
                <p-table [rows]="4"
                         [value]="taskDetailsNew"
                         [paginator]="false">
                    <ng-template pTemplate="header">
                            <tr [ngClass]="'textcolor'">
                                <th style="width: 18%;">{{'ProjectName' |localize}}</th>
                                <th style="width: 18%;">{{'Task'|localize}}</th>
                                <th>{{'Priority'|localize}}</th>
                                <th>{{'Severity'|localize}}</th>
                                <th>{{'Estimation'|localize}}</th>
                                <th>{{'TimeSpend'|localize}}</th>
                                <th class="">{{'Status'|localize}}</th>
                            </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-UserTaskListDashBoard>
                        <tr [ngClass]="'textcolor bg-hover-gray-100'">

                            <td>
                                <div class="d-flex flex-lg-fill">
                                    <div class="mr-4 project-image-container">
                                        <img *ngIf="UserTaskListDashBoard.projectImage" src="{{ UserTaskListDashBoard.projectImage }}" class="h-30px w-30px border border-light rounded" alt="" id="profimgsize" />
                                        <img *ngIf="!UserTaskListDashBoard.projectImage"
                                             src="{{ 'assets/common/images/projects/default image for project -1.png' }}"
                                             class="h-30px w-30px border border-light rounded"
                                             alt="" id="profimgsize"/>
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                        <span class="d-flex">
                                            <span class="font-size-base font-weight-bolder text-dark-65" pTooltip="{{ UserTaskListDashBoard.projectName }}" [tooltipDisabled]="DisableTooltip(UserTaskListDashBoard.projectName, 17)" tooltipPosition="bottom">{{ UserTaskListDashBoard.projectName | slice:0:17 }}{{ UserTaskListDashBoard.projectName.length > 17 ? '...' : '' }}</span>
                                        </span>
                                    </div>
                                </div>

                            </td>


                            <td>
                                <div class="d-flex flex-column">
                                    <span class="d-flex">
                                        <span class="font-size-base font-weight-bolder" pTooltip="{{ UserTaskListDashBoard.taskName }}" [tooltipDisabled]="DisableTooltip(UserTaskListDashBoard.taskName, 15)" tooltipPosition="bottom">{{ UserTaskListDashBoard.taskName | slice:0:15 }}{{ UserTaskListDashBoard.taskName.length > 15 ? '...' : '' }}</span>


                                    </span>
                                    <div class="d-flex flex-wrap align-items-center mt-1">
                                        <i *ngIf="UserTaskListDashBoard.billableType"></i>
                                        <span *ngIf="UserTaskListDashBoard.billableType && UserTaskListDashBoard.billableType == 1" class="text-dark-50 font-size-xs mr-2"><img src="assets/common/images/billable.png" alt="" width="14px"> | </span>
                                        <span *ngIf="UserTaskListDashBoard.billableType && UserTaskListDashBoard.billableType == 2" class="text-dark-50 font-size-xs mr-2"><img src="assets/common/images/nonbillable.png" alt="" width="14px"> | </span>
                                        <!--                                        <span class="text-dark-50 font-size-xs mr-2">Activity -</span>
                                        -->
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 1" class="text-dark-50 font-size-xs mr-2">{{'Development' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 2" class="text-dark-50 font-size-xs mr-2">{{'Design' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 3" class="text-dark-50 font-size-xs mr-2">{{'Requirement' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 4" class="text-dark-50 font-size-xs mr-2">{{'Documentation' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 5" class="text-dark-50 font-size-xs mr-2">{{'Testing' | localize}}</span>
                                        <span *ngIf="UserTaskListDashBoard.taskActivityId == 6" class="text-dark-50 font-size-xs mr-2">{{'Miscellaneous' | localize}}</span>

                                        <span *ngIf="!UserTaskListDashBoard.taskActivityId" class="label label-rounded label-light-success w-50px h-15px">-</span>
                                    </div>
                                    <!-- <div class="d-flex flex-wrap align-items-center mt-1">
                                        <i *ngIf="UserTaskListDashBoard.billableType"></i>
                                        <span *ngIf="UserTaskListDashBoard.billableType && UserTaskListDashBoard.billableType == 1" class="text-dark-50 font-size-xs mr-2"><img src="assets/common/images/billable.png" alt="" width="14px"> Billable</span>
                                        <span *ngIf="UserTaskListDashBoard.billableType && UserTaskListDashBoard.billableType == 2" class="text-dark-50 font-size-xs mr-2"><img src="assets/common/images/nonbillable.png" alt="" width="14px"> Non Billable</span>
                                        <span *ngIf="!UserTaskListDashBoard.isCurrentTaskActive" class="label label-rounded label-light-success w-50px h-15px">Active</span>

                                    </div> -->
                                </div>


                            </td>

                            <td>
                                <div class="d-flex flex-wrap align-items-center">
                                    <span *ngIf="UserTaskListDashBoard.taskPriorityId == 1" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 high-priority"></i>
                                        {{ 'High' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskPriorityId == 2" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 moderate-priority"></i>
                                        {{ 'Moderate' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskPriorityId == 3" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 low-priority"></i>
                                        {{ 'Low' | localize }}
                                    </span>
                                    <span *ngIf="!UserTaskListDashBoard.taskPriorityId" class="text-dark-50 font-size-sm mr-2">
                                        -
                                    </span>
                                </div>

                            </td>

                            <td>

                                <div class="d-flex flex-wrap align-items-center">
                                    <span *ngIf="UserTaskListDashBoard.taskSeverityId == 1" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 critical-severity"></i>
                                        {{ 'Critical' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskSeverityId == 2" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 high-severity"></i>
                                        {{ 'High' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskSeverityId == 3" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 medium-severity"></i>
                                        {{ 'Medium' | localize }}
                                    </span>
                                    <span *ngIf="UserTaskListDashBoard.taskSeverityId == 4" class="text-dark-50 font-size-sm mr-2">
                                        <i class="fa fa-circle icon-sm mr-2 low-severity"></i>
                                        {{ 'Low' | localize }}
                                    </span>
                                    <span *ngIf="!UserTaskListDashBoard.taskSeverityId" class="text-dark-50 font-size-sm mr-2">
                                        -
                                    </span>
                                </div>

                            </td>

                            <td>
                                <span>
                                    <span class="text-dark-50 font-size-sm">{{ getOriginalEstimateHour(UserTaskListDashBoard.originalEstimatedHours) }}</span>
                                </span>
                            </td>

                            <td>
                                <span>
                                    <span class="text-dark-50 font-size-sm">{{getHrsAndMinutes(UserTaskListDashBoard.totalCompletedHours | hourstoTimeSpan)}}</span>
                                </span>
                            </td>


                            <td>
                                <span>
                                    <span class="label label-outline-secondary  rounded-pill h-28px w-80px label-inline border  bg-white justify-content-start  text-center" [ngClass]="{'status-width':UserTaskListDashBoard.taskStatusId ==  4, 'w-105px':UserTaskListDashBoard.taskStatusId ==  2}">
                                        <span class=" span-allign-center text-center mx-auto">
                                            <span class="label label-dot" [ngClass]="{'label-primary':UserTaskListDashBoard.taskStatusId == 1,'label-warning':UserTaskListDashBoard.taskStatusId == 2,'label-danger':UserTaskListDashBoard.taskStatusId == 3,'label-success':UserTaskListDashBoard.taskStatusId == 4}"></span>
                                            <span *ngIf="UserTaskListDashBoard.taskStatusId  == 1" class="ml-2">{{'New' | localize}}</span>
                                            <span *ngIf="UserTaskListDashBoard.taskStatusId  == 2" class="ml-2">{{'InProgress1' | localize}}</span>
                                            <span *ngIf="UserTaskListDashBoard.taskStatusId == 3" class="ml-2">{{'Overdue' | localize}}</span>
                                            <span *ngIf="UserTaskListDashBoard.taskStatusId ==  4" class="ml-2">{{'Complete'| localize}}</span>
                                        </span>

                                    </span>
                                </span>


                            </td>
                        </tr>
                    </ng-template>
                </p-table>



            </div>
        </div>

    </div>




</div>






